import * as constants from '../constants'
export const setDealWonReason = payload => ({ payload, type: constants.SET_DEAL_WON_REASON })
export const setDealWonReasonFailure = payload => ({ payload, type: constants.SET_DEAL_WON_REASON_FAILURE })
